enum MailvistaUrls {
    OFFICIALSITE = "website",
    CONDITIONGENERALESUTILISATION = "cgu",
    CONDITIONGENERALESUTILISATIONPARTICULIER = "cgu particuliers",
    CONDITIONGENERALESUTILISATIONENTREPRISE = "cgu entreprise",
    POLITIQUECONFIDENTIALITE = "politique de confidentialit\u00E9",
    ONBOARDINGVIDEO = "video d accueil",
    MENTIONLEGALEWEB = "mentions l\u00E9gales web",
    MENTIONLEGALEAPPLICATION = "mentions l\u00E9gales application",
}

export default MailvistaUrls;
